import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BuilderRoutingModule } from './builder-routing.module';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { AuthModule, OpenIdConfiguration, StsConfigHttpLoader, StsConfigLoader, StsConfigStaticLoader } from 'angular-auth-oidc-client';
import { NgxPanZoomModule } from 'ngx-panzoom';
import { AppComponent } from '../../components/app/app.component';
import { OpenIdConfigService } from '../../services/openidconfig.service';
import { SharedModule } from '../shared/shared.module';
import { isObservable, Observable } from 'rxjs';
import { AddDocumentComponent } from '../../components/requestbuilder/adddocument/adddocument.component';
import { AddDocumentsDropzoneComponent } from '../../components/requestbuilder/adddocument/adddocumentsdropzone/adddocumentsdropzone.component';
import { DocumentListComponent } from '../../components/requestbuilder/adddocument/documentlist/documentlist.component';
import { DocumentListItemComponent } from '../../components/requestbuilder/adddocument/documentlist/documentlistitem/documentlistitem.component';
import { AddPersonsComponent } from '../../components/requestbuilder/addpersons/addpersons.component';
import { PersonListComponent } from '../../components/requestbuilder/addpersons/personlist/personlist.component';
import { PersonListItemComponent } from '../../components/requestbuilder/addpersons/personlist/personlistitem/personlistitem.component';
import { EditDataDialogComponent } from '../../components/requestbuilder/edit-data-dialog/edit-data-dialog.component';
import { EmailPreviewDialogComponent } from '../../components/requestbuilder/email-preview-dialog/email-preview-dialog.component';
import { RequestBuilderPage } from '../../components/requestbuilder/request-builder.page';
import { RequestHeaderComponent } from '../../components/requestbuilder/requestheader/requestheader.component';
import { RequestTitleComponent } from '../../components/requestbuilder/request-title/request-title.component';
import { ReviewandsendComponent } from '../../components/requestbuilder/reviewandsend/reviewandsend.component';
import { ReviewandsendactionslistComponent } from '../../components/requestbuilder/reviewandsend/reviewandsendactionslist/reviewandsendactionslist.component';
import { ReviewandsendactionslistitemComponent } from '../../components/requestbuilder/reviewandsend/reviewandsendactionslist/reviewandsendactionslistitem/reviewandsendactionslistitem.component';
import { ReviewandsenddocumentslistComponent } from '../../components/requestbuilder/reviewandsend/reviewandsenddocumentslist/reviewandsenddocumentslist.component';
import { ReviewandsenddocumentslistitemComponent } from '../../components/requestbuilder/reviewandsend/reviewandsenddocumentslist/reviewandsenddocumentslistitem/reviewandsenddocumentslistitem.component';
import { ReviewandsendsummaryComponent } from '../../components/requestbuilder/reviewandsend/reviewandsendsummary/reviewandsendsummary.component';
import { ReviewandsendsummaryitemComponent } from '../../components/requestbuilder/reviewandsend/reviewandsendsummary/reviewandsendsummaryitem/reviewandsendsummaryitem.component';
import { AddPersonZoneComponent } from '../../components/requestbuilder/addpersons/addpersonzone/addpersonzone.component';
import { FlowNavigationComponent } from '../../components/requestbuilder/flow-navigation/flow-navigation.component';
import { PersonDialogComponent } from '../../components/requestbuilder/person-dialog/person-dialog.component';
import { EditDocumentModalComponent } from 'src/app/components/requestbuilder/adddocument/edit-document-modal/edit-document-modal.component';
import { AddStationeryModalComponent } from 'src/app/components/requestbuilder/adddocument/add-stationery-modal/add-stationery-modal.component';
import { CloudDocumentUploadModal } from 'src/app/modals/cloud-document/cloud-document-upload.modal';
import { CloudDocumentExportModal } from 'src/app/modals/cloud-document/cloud-document-export.modal';
import { CloudDocumentListComponent } from 'src/app/modals/cloud-document/cloud-document-list/cloud-document-list.component';
import { RequestCreditSummaryComponent } from 'src/app/components/requestbuilder/reviewandsend/request-credit-summary/request-credit-summary.component';
import { Step3Component } from 'src/app/components/requestbuilder/step-3/step-3.component';
import { Step4Component } from 'src/app/components/requestbuilder/step-4/step-4.component';
import { ActionTableDocumentsComponent } from 'src/app/components/requestbuilder/step-3/action-table-documents/action-table-documents.component';
import { SendGroupComponent } from 'src/app/components/requestbuilder/step-4/send-group/send-group.component';
import { ChecklistComponent } from 'src/app/components/requestbuilder/step-3/checklist/checklist.component';
import { ActionTableDocumentActionsComponent } from 'src/app/components/requestbuilder/step-3/action-table-documents/action-table-document-actions.component';
import { ActionTableAllDocumentsComponent } from 'src/app/components/requestbuilder/step-3/action-table-documents/action-table-all-documents.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { DialogAddActionComponent } from 'src/app/components/requestbuilder/dialog-add-action/dialog-add-action.component';
import { ActionsByPersonComponent } from 'src/app/components/requestbuilder/step-4/send-group/actions-by-person/actions-by-person.component';
import { BuilderValidationMessagesComponent } from 'src/app/components/requestbuilder/builder-validation-messages/builder-validation-messages.component';
import { DocumentPlaceholderListItemComponent } from 'src/app/components/requestbuilder/adddocument/documentlist/documentplaceholderlistitem/documentplaceholderlistitem.component';
import { PersonPlaceholderListItemComponent } from 'src/app/components/requestbuilder/addpersons/personlist/personplaceholderlistitem/personplaceholderlistitem.component';
import { DateTimePickerComponent } from 'src/app/components/general/datetime-picker/datetime-picker.component';
import { SkeletonSendGroupsComponent } from 'src/app/components/general/skeleton/skeleton-send-groups.component';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';


const authFactory = (openIdConfigService: OpenIdConfigService) => {
  const config = openIdConfigService.getConfig();
  if (isObservable(config)) {
    return new StsConfigHttpLoader(<Observable<OpenIdConfiguration>>config);
  } else {
    return new StsConfigStaticLoader(<OpenIdConfiguration>config);
  }
};

@NgModule({
  declarations: [
    // Pages
    RequestBuilderPage,

    // Components
    BuilderValidationMessagesComponent,
    RequestTitleComponent,
    RequestHeaderComponent,
    AddDocumentComponent,
    AddDocumentsDropzoneComponent,
    DocumentListComponent,
    DocumentListItemComponent,
    AddPersonsComponent,
    PersonListComponent,
    PersonListItemComponent,
    DialogAddActionComponent,
    ReviewandsendComponent,
    EmailPreviewDialogComponent,
    EditDataDialogComponent,
    ReviewandsendactionslistComponent,
    ReviewandsendactionslistitemComponent,
    ReviewandsendsummaryComponent,
    ReviewandsendsummaryitemComponent,
    ReviewandsenddocumentslistComponent,
    ReviewandsenddocumentslistitemComponent,
    PersonDialogComponent,
    FlowNavigationComponent,
    AddPersonZoneComponent,
    PersonPlaceholderListItemComponent,
    DocumentPlaceholderListItemComponent,
    EditDocumentModalComponent,
    AddStationeryModalComponent,
    CloudDocumentUploadModal,
    CloudDocumentExportModal,
    CloudDocumentListComponent,
    RequestCreditSummaryComponent,
    Step3Component,
    ActionTableDocumentsComponent,
    ActionTableDocumentActionsComponent,
    ActionTableAllDocumentsComponent,
    ChecklistComponent,
    Step4Component,
    SendGroupComponent,
    ActionsByPersonComponent,
    DateTimePickerComponent,
    SkeletonSendGroupsComponent,
  ],
  imports: [
    CommonModule,
    BuilderRoutingModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    DragDropModule,
    NgxPanZoomModule,
    SharedModule,
    NgxSkeletonLoaderModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    AuthModule.forRoot({
      loader: {
        provide: StsConfigLoader,
        useFactory: authFactory,
        deps: [OpenIdConfigService],
      }
    }),
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
  ],
  exports: [
    CloudDocumentListComponent
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class BuilderModule { }

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}